// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".network-group-logo{display:inline-block}.network-group-logo__figure{margin:0;display:inline-block;text-align:center}.network-group-logo__figure img{width:36px;height:36px;border-radius:50%}.network-group-logo__figure .initials{font-size:15px;border:1px solid var(--color-display);color:var(--color-display);display:inline-block;height:27px;width:34px;border-radius:50%;font-weight:500;padding-top:7px;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
